<template>
  <CreateEditGroupModal
    v-if="showCreateEditGroupModal"
    :groupId="groupIdSelected"
    @closeModal="closeModal"
  />
  <DeleteGroupModal
    v-if="showDeleteGroupModal"
    :groupId="groupIdSelected"
    @closeModal="closeModal"
  />
  <div class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h4 class="py-3 mb-0">Grupos de Pesquisa</h4>
      <span class="text-muted ms-2 d-none d-sm-none d-md-block">
        Cadastre os grupos onde os templates de pesquisa serão atribuídos
      </span>
      <div class="ms-auto my-auto">
        <button
          type="button"
          class="btn btn-primary"
          title="Cadastrar Grupo"
          @click="createEditGroup()"
        >
          Cadastrar Grupo
        </button>
      </div>
    </div>
    <LoadingData v-if="isLoadingData" class="my-3" />
    <ListGroups
      v-else
      :groups="groups"
      @createEditGroup="createEditGroup"
      @deleteGroup="deleteGroup"
    />
  </div>
</template>

<script>
import CreateEditGroupModal from '@/components/params/groups/CreateEditGroupModal.vue'
import DeleteGroupModal from '@/components/params/groups/DeleteGroupModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListGroups from '@/components/params/groups/ListGroups.vue'

export default {
  name: 'Groups',

  components: {
    CreateEditGroupModal,
    DeleteGroupModal,
    LoadingData,
    ListGroups,
  },

  data() {
    return {
      isLoadingData: true,
      showCreateEditGroupModal: false,
      showDeleteGroupModal: false,
      groups: [],
      groupIdSelected: null,
    }
  },

  methods: {
    async getGroups() {
      try {
        this.groups = await this.$store.dispatch('getGroups')
        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    createEditGroup(groupId) {
      this.groupIdSelected = groupId || null
      this.showCreateEditGroupModal = true
    },

    deleteGroup(groupId) {
      this.groupIdSelected = groupId
      this.showDeleteGroupModal = true
    },

    closeModal(needReload) {
      if (needReload) {
        this.getGroups()
      }
      this.showCreateEditGroupModal = false
      this.showDeleteGroupModal = false
    },
  },

  mounted() {
    this.getGroups()
  },
}
</script>
